import { computed } from 'vue'
import { currentAdmin } from '../services/auth.js'

/**
 * Reactive RBAC composable.
 * Works from the permissions array stored in localStorage (set at login / me refresh).
 */
export function usePermission() {
  const admin = computed(() => currentAdmin())
  const permissions = computed(() => admin.value?.permissions ?? [])

  function can(permission) {
    const perms = permissions.value
    return perms.includes('system.all') || perms.includes(permission)
  }

  function canAny(...keys) {
    return keys.some(k => can(k))
  }

  function canAll(...keys) {
    return keys.every(k => can(k))
  }

  const isSuperAdmin = computed(() => can('system.all'))

  return { can, canAny, canAll, isSuperAdmin, permissions }
}
